import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { DashboardContent } from './dashboard-content'
import { Fragment } from 'react/jsx-runtime'
import { Footer } from '../components/footer'
export default function Dashboard() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="dashboard">
        <DashboardContent />
       </SidebarLayoutNew>
      <Footer />
    </Fragment>
  );
}